import { IState } from "@redux/store.types";
import { generateDefaultSelectors, getApiDataState } from "@redux/utils";

import { $PhonenumberPrefixesModuleName } from "./phonenumberPrefixes.types";

const { isLoading, error, isSuccessfullyLoaded } =
    generateDefaultSelectors($PhonenumberPrefixesModuleName);

const getPhonenumberPrefixes = (state: IState) => {
    return getApiDataState(state, $PhonenumberPrefixesModuleName)?.data || [];
};

export { getPhonenumberPrefixes, isLoading, error, isSuccessfullyLoaded };
